module.exports = __webpack_public_path__ + "img/banner-27.cee0a1c2.jpg";